import moment from "moment";
import { useEffect } from "react";
import { downloadApiData, } from "../../../../helpers/AxiosInstance";
const ExcelUpload = (props: any) => {
  const { url, fileName, register, watch, errors, setError } = props;
  const handleDownloadSampleFile = async () => {
    try {
      await downloadApiData(`${url}download-bulk-upload-sample-file/`, `${fileName}-${moment().format('MMMM-Do-YYYY-h-mm-ss')}.xlsx`)
    } catch (e) {
      console.log(e)
    }
  };

  const file = watch(register?.name)
  useEffect(() => {
    setError(register?.name, {})
  }, [file])


  return (
    <>
      <div className="extraOutline p-4 bg-white bg-whtie m-auto rounded-lg w-full">
        <div className="file_upload p-5 relative border-4 border-dotted border-gray-300 rounded-lg" >
          <button className="absolute right-5 text-primary" type="button" onClick={handleDownloadSampleFile}>Download Sample File</button>
          <div className="input_field flex flex-col w-full mx-auto text-center">
            <label>
              <input className="text-sm cursor-pointer w-full hidden" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" {...register} onBlur={() => console.log("test")} />
              <svg className="text-primary w-full mx-auto mb-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" height={"100px"} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>
            </label>
            <div className="title text-primary uppercase">{file?.length ? `Selected File:- ${file[0]?.name}` : ""}</div>
            <p className="text-sm text-red-600">{errors[register?.name]?.message}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExcelUpload;
